// extracted by mini-css-extract-plugin
export var attribution = "_21-4";
export var authorName = "_21-5";
export var option = "_21-f";
export var optionCard = "_21-u";
export var optionContent = "_21-v";
export var optionGrid = "_21-11";
export var optionIcon = "_21-x";
export var optionIconBox = "_21-w";
export var optionLabel = "_21-y";
export var optionList = "_21-e";
export var optionPill = "_21-12";
export var optionPillBadge = "_21-15";
export var optionPillIcon = "_21-13";
export var optionPillLabel = "_21-14";
export var optionRadio = "_21-z";
export var optionRadioInner = "_21-10";
export var optionReveal = "_21-h";
export var optionRevealDelay0 = "_21-i";
export var optionRevealDelay1 = "_21-j";
export var optionRevealDelay10 = "_21-s";
export var optionRevealDelay11 = "_21-t";
export var optionRevealDelay2 = "_21-k";
export var optionRevealDelay3 = "_21-l";
export var optionRevealDelay4 = "_21-m";
export var optionRevealDelay5 = "_21-n";
export var optionRevealDelay6 = "_21-o";
export var optionRevealDelay7 = "_21-p";
export var optionRevealDelay8 = "_21-q";
export var optionRevealDelay9 = "_21-r";
export var optionSelected = "_21-g";
export var questionsBlock = "_21-17";
export var quote = "_21-3";
export var spacer = "_21-b";
export var stepCenteredContent = "_21-9";
export var stepInner = "_21-6";
export var stepInnerFullWidth = "_21-7";
export var stepInnerLockScroll = "_21-8";
export var stepTransitionFrame = "_21-a";
export var subtitle = "_21-d";
export var testimonial = "_21-2";
export var title = "_21-c";
export var trustedBy = "_21-0";
export var trustedByLabel = "_21-1";
export var welcomeBlock = "_21-16";